/**
 * Qantas Shopping Points-Prompter — cashback / points prompter
 *
 * Declares one WAR group matched to every URL (and google.com) with no use_dynamic_url:
 * an offer icon, assets/*.woff fonts, and two source-map files. The source maps ship
 * only as .LICENSE.txt on disk, so detection uses the vendor-named PNG icon (loads via
 * <img> without a CORS grant) plus the Ciutadella brand font at a fixed URL.
 *
 * Manifest verified against version 3.0.8.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jchomknmfdaeojlimglgebnjlijedgnk';

export const qantasShopping: ExtensionDefinition = {
  id: ID,
  name: 'Qantas Shopping Points-Prompter',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Static offer icon and brand font on every origin with no dynamic URL. The PNG icon ' +
    'loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-offer-available-png',
      kind: 'web-accessible-resource',
      description:
        'Load assets/icons/offer_available_32x32.png via <img> — the offer-available ' +
        'toolbar icon exposed to every origin; needs no CORS grant, so it survives a ' +
        'strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'assets/icons/offer_available_32x32.png'),
    },
    {
      id: 'war-ciutadella-woff',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/Ciutadella-Regular.woff — the Qantas brand font, corroborating from ' +
        'an independent stable path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/Ciutadella-Regular.woff'),
    },
  ],
};
